<div *ngIf="content" [class.no-padding]="noPadding" [innerHTML]="content | unescape | toTrustedHtml" class="strapi"></div>
